(function () {
  'use strict';

  function text(value) { return value == null ? '' : String(value).trim(); }
  function standard(value) {
    var result = text(value);
    if (/DIN EN 755-9/i.test(result)) {
      return result
        .replace(/DIN EN 573(?:-3)?\s*\/\s*/i, '')
        .replace(/\s*\/\s*DIN EN 573(?:-3)?$/i, '')
        .replace(/DIN EN 755-9/gi, 'DIN EN 755')
        .trim();
    }
    return result.replace(/DIN EN 755-9/gi, 'DIN EN 755');
  }
  function number(value) {
    return text(value) !== '' && Number.isFinite(Number(value)) ? Number(value) : null;
  }
  function baseAlloy(value, facts) {
    var alloy = text(value).split(/[_\s]/)[0];
    if (/^eloxiert$/i.test(alloy)) {
      return /^Al[A-Za-z0-9,.]+$/.test(text(facts.alloy)) ? text(facts.alloy) : '';
    }
    return alloy;
  }
  function materialNumber(alloy, source) {
    // A designation is only used if it also exists in this product's maintained metadata.
    var candidates = {
      'almgsi0,5': ['6060'], 'almgsi0,7': ['6063', '6005', '6005A'],
      'almgsi1': ['6082'], 'almgsibi': ['6026'], 'alcumgpb': ['2007'],
      'alcumg1': ['2017', '2017A'], 'alcubipb': ['2011'],
      'almg1': ['5005', '5005A'], 'almg3': ['5754'],
      'almg4,5mn': ['5083'], 'alznmgcu1,5': ['7075'], 'al99,5': ['1050', '1050A']
    }[text(alloy).toLowerCase().replace(/\.(?=\d)/g, ',')] || [];
    var codes = text(source).match(/\b\d{4}[A-Z]?\b/g) || [];
    var matches = codes.filter(function (code, index) {
      return candidates.indexOf(code) !== -1 && codes.indexOf(code) === index;
    });
    return matches.length === 1 ? 'EN AW-' + matches[0] : '';
  }
  function surface(row, facts, messages) {
    if (text(row.Oberflaeche)) return text(row.Oberflaeche);
    var raw = text(row.Legierung).toLowerCase();
    var maintained = text(facts.surface).toLowerCase();
    if (/elox/.test(raw)) {
      if (facts.plate && /einseitig eloxiert|anodized on one side/.test(maintained)) return messages.plate_anodized;
      if (maintained.indexOf('e6/ev1') !== -1) return messages.anodized_e6;
      if (/silber|silver/.test(maintained) || /silber/.test(raw)) return messages.anodized;
      return messages.missing;
    }
    if (/feinstgefräst/.test(raw) && /feinstgefräst|precision.milled/.test(maintained)) return messages.milled;
    if (/je nach variante|depending on (?:the )?(?:variant|version)/.test(maintained)) {
      if (/pressblank|mill finish/.test(maintained) && /^Al/.test(text(row.Legierung))) return messages.mill_finish;
      if (facts.plate && /walzblank|as.rolled|mill-finished/.test(maintained) && /^Al/.test(text(row.Legierung))) return messages.rolled_finish;
      return messages.missing;
    }
    if (/^(eloxiert silber|silber eloxiert|silver anodized)$/.test(maintained)) return messages.anodized;
    return text(facts.surface) || messages.missing;
  }
  function findRow(data, controls) {
    if (!data || typeof data !== 'object') return null;
    if (!Array.isArray(data)) return data.SKU ? data : null;
    var matches = data.filter(function (row) {
      return row.Abmessung === controls.dimension && row.Legierung === controls.alloy;
    });
    if (!matches.length) return null;
    var fields = ['Abmessung', 'Legierung', 'MaxLaenge', 'MaxBreite', 'Oberflaeche', 'Norm'];
    return matches.every(function (row) {
      return fields.every(function (key) { return row[key] === matches[0][key]; });
    }) ? matches[0] : null;
  }
  function buildSelection(row, controls, facts, messages) {
    var output = {};
    var format = new Intl.NumberFormat(facts.locale, { maximumFractionDigits: 3 });
    function mm(value) { return format.format(value) + ' mm'; }
    ['dimensions', 'alloy', 'material_number', 'surface', 'cut_range', 'length_tolerance', 'standard'].forEach(function (key) {
      output[key] = messages.pending;
    });
    if (facts.plate) output.length_tolerance = text(facts.lengthTolerance);
    if (controls.dimension) output.dimensions = text(controls.dimension);
    if (!row) return output;
    var alloy = baseAlloy(row.Legierung, facts);
    var grade = materialNumber(alloy, facts.grade);
    output.alloy = alloy ? (/^en/i.test(facts.locale) ? alloy.replace(/,(?=\d)/g, '.') : alloy) : messages.missing;
    output.material_number = grade || messages.missing;
    output.surface = surface(row, facts, messages);
    output.standard = standard(text(row.Norm) || (alloy && grade ? text(facts.standard) : '')) || messages.missing;
    var dimensions = text(row.Abmessung);
    if (/^en/i.test(facts.locale)) dimensions = dimensions.replace(/,(?=\d)/g, '.');
    output.dimensions = dimensions ? dimensions + (/\bmm\b/i.test(dimensions) ? '' : ' mm') : messages.missing;
    var min = number(controls.minimum);
    var max = number(row.MaxLaenge);
    var widthMax = number(row.MaxBreite);
    var widthMin = number(controls.widthMinimum);
    output.cut_range = min > 0 && max >= min ? mm(min) + ' \u2013 ' + mm(max) : messages.missing;
    if (facts.plate && widthMax > 0) {
      output.cut_range = messages.length + ': ' + output.cut_range + '; ' + messages.width + ': ' +
        (widthMin > 0 ? mm(widthMin) + ' \u2013 ' : '') + mm(widthMax);
    }
    var length = number(controls.length);
    var width = number(controls.width);
    if (facts.plate) {
      if (length > 0) output.dimensions += '; ' + messages.length + ': ' + mm(length);
      if (width > 0) output.dimensions += '; ' + messages.width + ': ' + mm(width);
    }
    if (!text(controls.length)) output.length_tolerance = messages.length_pending;
    else if (length === null || length % 1 || min === null || max === null || length < min || length > max) {
      output.length_tolerance = messages.invalid_length;
    } else if (facts.plate) {
      output.length_tolerance = text(facts.lengthTolerance);
    } else if ([1000, 2000, 3000].indexOf(length) !== -1 || controls.stockWarning) {
      output.length_tolerance = messages.stock_tolerance;
    } else {
      output.length_tolerance = length <= 500 ? messages.tolerance_small : messages.tolerance_large;
    }
    return output;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { findRow: findRow, buildSelection: buildSelection, materialNumber: materialNumber };
  }
  if (typeof document === 'undefined') return;

  function initialize(root) {
    if (root.dataset.technicalReady) return;
    var settings = root.querySelector('[data-technical-settings]');
    var section = root.closest('.product-section');
    if (!settings || !section) return;
    var facts;
    try { facts = JSON.parse(settings.textContent); } catch (_) { return; }
    if (section.dataset.productId !== facts.productId) return;
    var length = section.querySelector('#length');
    var configurator = length && length.closest('.pk-container');
    if (!configurator) return;
    root.dataset.technicalReady = 'true';
    var cells = Array.from(root.querySelectorAll('[data-technical-value]'));
    var initial = cells.map(function (cell) { return cell.textContent; });
    var context = root.querySelector('[data-technical-context]');
    var initialContext = context.textContent;
    var queued = false;
    function update() {
      queued = false;
      if (!root.isConnected) return;
      var diameter = configurator.querySelector('#durchmesser-select');
      var alloy = configurator.querySelector('#legierung-select');
      var width = configurator.querySelector('#width');
      var minimum = length.min || facts.minimum && text(facts.minimum).match(/^\s*(\d+(?:[.,]\d+)?)\s*mm\s*$/i);
      minimum = Array.isArray(minimum) ? minimum[1].replace(',', '.') : minimum;
      var widthMinimum = width && width.min;
      // Read the app's existing limits, never change its controls or calculations.
      try {
        if (typeof minLength !== 'undefined') minimum = minLength;
        if (typeof minWidth !== 'undefined') widthMinimum = minWidth;
      } catch (_) { /* The app can still be initializing. */ }
      var controls = {
        dimension: diameter && diameter.selectedIndex > 0 ? diameter.value : '',
        alloy: alloy && alloy.selectedIndex > 0 ? alloy.value : '',
        length: length.value, width: width && width.value,
        minimum: minimum, widthMinimum: widthMinimum,
        stockWarning: Array.from(configurator.querySelectorAll('.length-warning')).some(function (warning) {
          return warning.getClientRects().length && getComputedStyle(warning).display !== 'none';
        })
      };
      var data = window.configuration_json;
      var marker = configurator.querySelector('#product-id');
      if (!marker || marker.textContent.trim() !== facts.productId) return;
      if (!data || typeof data !== 'object') return;
      var row = findRow(data, controls);
      var untouched = !controls.dimension && !controls.alloy && !text(controls.length) && (!data || Array.isArray(data));
      if (untouched) {
        cells.forEach(function (cell, index) { if (cell.textContent !== initial[index]) cell.textContent = initial[index]; });
        context.textContent = initialContext;
        return;
      }
      var currentFacts = Object.assign({}, facts, { plate: facts.plate || !!width });
      var values = buildSelection(row, controls, currentFacts, facts.messages);
      cells.forEach(function (cell) {
        var value = values[cell.dataset.technicalValue];
        if (cell.textContent !== value) cell.textContent = value;
      });
      if (context.textContent !== facts.messages.selection) context.textContent = facts.messages.selection;
    }
    function schedule() {
      if (!queued) { queued = true; requestAnimationFrame(update); }
    }
    configurator.addEventListener('change', schedule);
    configurator.addEventListener('input', schedule);
    var observer = new MutationObserver(schedule);
    observer.observe(configurator, { childList: true, subtree: true, attributes: true, attributeFilter: ['max', 'min', 'disabled', 'aria-busy', 'style'] });
    window.addEventListener('pageshow', schedule);
    function unload(event) {
      if (!event.target.contains(root)) return;
      observer.disconnect();
      window.removeEventListener('pageshow', schedule);
      configurator.removeEventListener('change', schedule);
      configurator.removeEventListener('input', schedule);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    schedule();
  }
  function boot(scope) {
    scope.querySelectorAll('[data-technical-selection]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
